// constants.js

export const objectiveData = [
  { id: '1', text: 'WebsiteTraffic' },
  { id: '2', text: 'Branding & Reach' },
  { id: '3', text: 'Conversions / Lead Generation' },
]

export const businessTypeData = [
  { id: '1', text: 'Business1' },
  { id: '2', text: 'Business2' },
  { id: '3', text: 'Business3' },
]


export const formFeildsDayPart = {
  startDate: {
    key: 'startDate',
    label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
}

export const formFeildsAgeFromTo = {
  ageFrom: {
    key: 'ageFrom',
    // label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  ageTo: {
    key: 'ageTo',
    // label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
}

export const formFeildAge = {
  ageGoogleAds: {
    key: 'ageGoogleAds',
    // label: 'Gender',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
}

export const formFeildfacebookPageList = {
  fbPageList: {
    key: 'fbPageList',
    label: 'Choose Page',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    labelLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
  fbPageAccount: {
    key: 'fbPageAccount',
    label: 'Choose Seat',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'accountId',
    textKey: 'accountId',
  },
}

export const formFields = {
  strategyName: {
    key: 'strategyName',
    type: 'text',
    label: 'Strategy Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },

  biddingStrategy: {
    key: 'biddingStrategy',
    label: 'Bidding Strategy',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  pacing: {
    key: 'pacing',
    label: 'Pacing',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  gender: {
    key: 'gender',
    label: 'Gender',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
    addBreakOptional: false
  },

  device: {
    key: 'device',
    label: 'Device',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  language: {
    key: 'language',
    label: 'Language ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
    addBreakOptional: false
  },

  sDate: {
    key: 'sDate',
    label: 'Start Date',  
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  
  eDate: {
    key: 'eDate',
    label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  duration: {
    key: 'duration',
    label: 'Duration ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  budget: {
    key: 'budget',
    type: 'number',
    label: 'Budget',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 99999999,
    upto4Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },

  onScreenFb: {
    key: 'onScreenFb',
    // label: 'On Screen Position Details for Facebook',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'value',
    textKey: 'label',
  },
  onScreenIon: {
    key: 'onScreenIon',
    // label: 'On Screen Position Details for Facebook',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'value',
    textKey: 'label',
  },




  audience: {
    key: "audience",
    type: "text",
    // label: "Audience",
    placeholder: "Press 'Enter' to add the Audience",
    required: false,
    requiredMessage: "This field is required.",
    displayLayout: "col-md-12 px-0",
    tooltip: "<div> Tags </div>",
  },
  keywords: {
    key: "keywords",
    type: "text",
    // label: "Audience",
    placeholder: "Press 'Enter' to add the Keywords",
    required: false,
    requiredMessage: "This field is required.",
    displayLayout: "col-md-12 px-0",
    tooltip: "<div> Tags </div>",
  },
  sites: {
    key: "sites",
    type: "text",
    // label: "Audience",
    placeholder: "Press 'Enter' to add the Sites",
    required: false,
    requiredMessage: "This field is required.",
    patternMessage:"Please enter valid site URL",
    displayLayout: "col-md-12 px-0",
    tooltip: "<div> Tags </div>",
    pattern: /^(https?:\/\/)([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)(\/.*)?$/,

  },
  frequencyCapTime: {
    key: 'frequencyCapTime',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

};


export const dayOfWeekMap = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};